import * as React from 'react';
import {observer} from "mobx-react-lite";
import moment from "moment";

const DateRow = observer(function DateRow(props: {timestamp?: number}) {
    if (!props.timestamp) {
        return <span>Never</span>
    }

    return <span className="dateRow"
        title={moment(props.timestamp * 1000).toISOString()}>
        {moment(props.timestamp * 1000).fromNow()}
    </span>
});

export default DateRow